import React, { useContext, useEffect, useState } from "react";
import classes from "./EditServices.module.scss";
import { Collapse, Container, OverlayTrigger, Row, Tooltip,Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { DDD, E2Data } from "../lib/ddd/ddd";
import { OrgIdContext } from "../store/orgId_context";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import Button from "../components/UI/Button";
import LoadingDots from "../components/UI/LoadingDots";
import { useForm } from "react-hook-form";
import WarningTooltip from "../components/profileComponents/WarningTooltip";
import FileUploader from "../components/profileComponents/fields/FileUploader";
import ImageUploader from "../components/profileComponents/fields/ImageUploader";
import { NotificationManager} from 'react-notifications';
import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const e2Data = new E2Data("EU_AOrg");
e2Data.format="Full";
const ddd = new DDD(apiRequestAddress);


const InvoiceSettings = () => {
    const { integrationDevice, aboutOrgId, sessionInfo} = useContext(OrgIdContext);
    const [invoiceId, setInvoiceId] = useState();
    const [noInvoiceFound, setNoInvoiceFound] = useState(false);
    const [creatingNewInvoice, setCreatingNewInvoice] = useState(false);
    const [creatingError, setCreatingError] = useState(false);
    const [saving, setSaving] = useState(false);
    const [forceRefresh, setForceRefresh] = useState(0);
    const {t} = useTranslation();
    
    const {isPending : isDataPending, data} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
        refetchOnWindowFocus: false,
    })

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm(/*defaultone*/);


    useEffect(() => {
        if(!data) return;
        setValue("Web", data?.result?.data?.[0]?.Web||null);
        setValue("Logo", data?.result?.data?.[0]?.Logo||null);
        setValue("Stamp", data?.result?.data?.[0]?.Stamp||null);
        setValue("Signer", data?.result?.data?.[0]?.Signer||null);
        setValue("SignScan", data?.result?.data?.[0]?.SignScan||null);
        setValue("Email", data?.result?.data?.[0]?.Email||null);
        setValue("Telephone", data?.result?.data?.[0]?.Telephone||null);
        setValue("AddInfo", data?.result?.data?.[0]?.AddInfo||null);
    },[data]);


    useEffect(() => {
        /* if(invoiceId || noInvoiceFound) return;

        const data = new E2Data("EU_Invoices");
        data.orderBy="DateTimeCreate desc";
        data.filter = "Mode = 'TEST' OR Mode = ''";
        data.take = 1;
        data.GetData().then((res) => {
            if(res?.result?.data?.[0]?.Id){
                setInvoiceId(res.result.data[0].Id);
            }else{
                setNoInvoiceFound(true);
            }
        }); */
    }, []);

    const createNewInvoice = () => {
        setCreatingNewInvoice(true);
        const data = new E2Data("IL_EU_CacheByCountry");
        data.format = "full";
        data.GetData().then((res) => {//CountryCodeSC__CountryCode	"MD"
            let country = res?.result?.data?.find((country) => sessionInfo?.Extended?.CountryCodeSC__CountryCode?.toLowerCase() === country.Country__CountryCodeISOC2?.toLowerCase());
            if(!country)
                country = res?.result?.data?.find((country) => country.Country===null || country.Country === undefined);
            if(!country) return setCreatingError(t("Unable to automatically create an invoice. Please create one manually."));
            const invoice = JSON.parse(country.DDDI_GetExisting);

            delete invoice?.Result?.Invoice?.Invoice?.DocSigner;
            delete invoice?.Result?.Invoice?.Invoice?.DocNumber;
            delete invoice?.Result?.Invoice?.Invoice?.DocSignerScan;

            const ddd = DDD.WithConnectionKey(apiRequestAddress,integrationDevice);
            ddd.DDDI_Save({"Object" : invoice?.Result?.Invoice?.Invoice, Complexity : "Normal"}).then((res) => {
                if(res?.Status === "Error") return setCreatingError(t("Unable to automatically create an invoice. Please create one manually."));
                setNoInvoiceFound(false);
                setCreatingNewInvoice(false);
                setInvoiceId(res?.Id);
            });
        });
    }
    const saveDataSubmit = (data) =>{
        setSaving(true);
        const save = new E2Data("EU_AOrg");
        save.values = data;
        save.filter = `Id = '${aboutOrgId}'`;
        save.Modify().then((res) => {
            if(res?.result?.status==="ok"){
                NotificationManager.success("", t("Saved!"));
                ddd.InvalidateSessionExtensions();
                //setNoInvoiceFound(true);
                //createNewInvoice();
                setForceRefresh(forceRefresh+1);
            }else{
                NotificationManager.warning("", res?.error?.data || t("Saved!"));
            }
            setSaving(false);
        });
    }
    const append = sessionInfo?.Extended?.Theme === "GVC" ? "?gvc=true" : "";

    return (
    <>
      <Helmet>
        <title>PDF customization | DDD Invoices</title>
      </Helmet>
      <div className={`h-100 w-100 p-5 ${classes.container}`}>
        <Row className="h-100">
            <Col className="col-4 h-100 d-flex">
                <div className={`${classes["panel"]} d-flex flex-column w-100`}>
                    <div className="text-center">
                        <h2>{t("PDF customization")}</h2>
                        <p>{t("Here you can set up your PDF appearance.")}</p>
                    </div>
                    <div className="flex-fill ps-2 pe-2" style={{overflow:"auto"}}>
                        <form id="invoiceForm" className={classes["settings-form"]} onSubmit={handleSubmit(saveDataSubmit)}>
                            <div className="mt-3" style={{borderBottom:"1px solid", fontWeight:"bold"}}>{t("Company")}:</div>
                            <fieldset className={classes["input-container"]}>
                                <label htmlFor="Web">{t("Website URL")}
                                {errors.Web && <>
                                    <WarningTooltip text={errors.Web?.message}/>
                                    </>}</label>
                                <input
                                    type="text"
                                    name="Web"
                                    id="Web"
                                    style={errors.Web ? {outlineColor:"red"}: {}}
                                    {...register("Web")}
                                    placeholder={t("Enter your website URL")}
                                />
                            </fieldset>
                            <fieldset className={classes["input-container"]}>
                                <label htmlFor="Email">{t("Email")}
                                {errors.Email && <>
                                    <WarningTooltip text={errors.Email?.message}/>
                                    </>}</label>
                                <input
                                    type="text"
                                    name="Email"
                                    id="Email"
                                    style={errors.Email ? {outlineColor:"red"}: {}}
                                    {...register("Email")}
                                    placeholder={t("example@email.com")}
                                />
                            </fieldset>
                            <fieldset className={classes["input-container"]}>
                                <label htmlFor="Telephone">{t("Telephone")}
                                {errors.Telephone && <>
                                    <WarningTooltip text={errors.Telephone?.message}/>
                                    </>}</label>
                                <input
                                    type="text"
                                    name="Telephone"
                                    id="Telephone"
                                    style={errors.Telephone ? {outlineColor:"red"}: {}}
                                    {...register("Telephone")}
                                    placeholder={t("Telephone number")}
                                />
                            </fieldset>

                            <div className="d-flex justify-content-around">
                                <fieldset className={classes["input-container"]}>
                                    <label htmlFor="Logo">{t("Logo")}
                                    {errors.Logo && <>
                                        <WarningTooltip text={errors.Logo?.message}/>
                                        </>}</label>
                                    <ImageUploader name={"Logo"}
                                                register={register}
                                                setValue={setValue}
                                                control={control}
                                                inEditMode = {true}/>
                                </fieldset>
                                <fieldset className={classes["input-container"]}>
                                <label htmlFor="Logo">{t("Stamp")}
                                    {errors.Stamp && <>
                                        <WarningTooltip text={errors.Stamp?.message}/>
                                        
                                        </>}</label>
                                    <ImageUploader name={"Stamp"}
                                                register={register}
                                                setValue={setValue}
                                                control={control}
                                                inEditMode = {true}/>
                                </fieldset>
                            </div>
                            <div className="mt-5" style={{borderBottom:"1px solid", fontWeight:"bold"}}>{t("Signature")}:</div>
                            <div className="d-flex justify-content-around">
                                <fieldset className={classes["input-container"]}>
                                    <label htmlFor="Signer">{t("Signer")}
                                    {errors.Signer && <>
                                        <WarningTooltip text={errors.Signer?.message}/>
                                        </>}</label>
                                    <input
                                        type="text"
                                        name="WeSignerb"
                                        id="Signer"
                                        style={errors.Telephone ? {outlineColor:"red"}: {}}
                                        {...register("Signer")}
                                        placeholder={t("Enter signer’s name")}
                                    />
                                </fieldset>
                                <fieldset className={classes["input-container"]}>
                                    <label htmlFor="SignScan">{t("Signature scan")}
                                    {errors.SignScan && <>
                                        <WarningTooltip text={errors.SignScan?.message}/>
                                        
                                        </>}</label>
                                    <FileUploader name={"SignScan"}
                                                register={register}
                                                setValue={setValue}
                                                control={control}
                                                inEditMode = {true}/>
                                </fieldset>
                            </div>
                            <fieldset className={classes["input-container"]} style={{width:"100%", marginBottom:"1.5rem"}}>
                                <label htmlFor="AddInfo">{t("Additional Info")}
                                <OverlayTrigger placement="top" overlay={<Tooltip>{t("Additional legal or admin notes you’d like to communicate to your clients. This will be inserted on the bottom of the PDF invoice. The display of this information on the generated PDF invoice can be")} <b>{t("enabled")}</b> {t("or")} <b>{t("disabled")}</b> {t("upon request. To request either option, please contact support at support@dddinvoices.com with the subject line Seller AdditionalInfo.")}</Tooltip>}>
                                    <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
                                </OverlayTrigger>
                                {errors.AddInfo && <>
                                    <WarningTooltip text={errors.AddInfo?.message}/>
                                    </>}</label>
                                <textarea
                                    name="AddInfo"
                                    id="AddInfo"
                                    style={errors.AddInfo ? {outlineColor:"red"}: {}}
                                    {...register("AddInfo")}
                                    placeholder="Info"
                                />
                            </fieldset>
                            {/* <div className="text-center mt-auto">
                                <Button type="submit" className="px-5 py-1 ms-3" disabled ={saving}>
                                    {t("Save")}
                                </Button>
                            </div> */}
                        </form>
                    </div>
                    <div className="text-center mt-4">
                        <Button type="submit" className="px-5 py-1 ms-3" disabled ={saving} onClick={() => document.getElementById('invoiceForm').dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}>
                            {t("Save")}
                        </Button>
                    </div>
                </div>
                {/* <div className={`${classes["panel"]} d-flex flex-column h-100`}>
                    <h2>{t("Invoice settings")}</h2>
                    <p>{t("Here you can set up your invoice settings.")}</p>
                    
                </div> */}
            </Col>
            <Col className="h-100">
                <div className={`${classes["panel"]} d-flex flex-column h-100`} style={{position:"relative"}}>
                    <h2>
                        {t("Preview")}
                        <OverlayTrigger overlay={<Tooltip>{t("This is only a preview of your last created invoice. In case you edit your information on the left a new test invoice is generated.")}</Tooltip>}>
                            <HelpIcon  />
                        </OverlayTrigger>
                    </h2>
                    <div style={{flex:"1"}} /* className={noInvoiceFound ? classes["nodata-blur"] : null} */>
                        <iframe 
                        src={process.env.REACT_APP_ORIGIN ? process.env.REACT_APP_ORIGIN+`/invpreview`+append : `/invpreview`+append}
                        frameBorder="0"
                        title="edit-invoices-layout"
                        style={{ width: "100%", height: "100%" }}
                        key={forceRefresh}
                        ></iframe>
                    </div>
                    {/* {noInvoiceFound && <div className={`rounded bg-white text-black border border-dark p-4 ${classes["iframe-nodata"]}`}>
                        {creatingNewInvoice && !creatingError && <>
                            {t("Loading...")}
                            <LoadingDots/>
                        </>}
                        {!creatingNewInvoice && !creatingError && <>
                            {t("You have no invoices yet. Please create at least one test invoice to see the preview or click the button to create a random one: ")}
                            <Button onClick={createNewInvoice}>{t("Click here")}</Button>
                        </>}
                        {creatingError && <div className="text-danger">{creatingError}</div>}
                    </div>} */}
                </div>
            </Col>
        </Row>
      </div>
    </>
    );
};

export default InvoiceSettings;
